import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import CheckIcon from '../../icons/utility/CheckIcon';
import useColorOverrides from './useColorOverrides';
const CheckboxSquare = ({ isChecked, isHovered, isFocused, styles, disabled }) => {
    const { borders, inputs } = useTheme();
    const marginStyles = useComponentMargin({ marginVertical: 'small', marginRight: 'small' });
    const { backgroundColor, borderColor } = useColorOverrides({ isChecked, isHovered, disabled });
    const mergedStyles = useMemo(() => ({
        ...marginStyles,
        ...borders.base,
        borderRadius: '0.5rem',
        minWidth: '2.4rem',
        backgroundColor,
        borderColor,
        ...(isFocused && inputs.choiceStyles.focused),
        ...styles
    }), [isFocused, styles, backgroundColor, borders, borderColor, inputs, marginStyles]);
    const checkmarkSizeProps = useMemo(() => ({
        width: '80%',
        height: '80%',
        x: '10%',
        y: '10%'
    }), []);
    return (React.createElement("svg", { viewBox: "0 0 24 24", width: 24, style: mergedStyles },
        React.createElement("rect", { width: 24, height: 24, fill: backgroundColor }),
        isChecked && React.createElement(CheckIcon, { size: "small", ...checkmarkSizeProps, type: "inverted" })));
};
export default CheckboxSquare;
//# sourceMappingURL=index.js.map